import axios from 'axios';
import queryString from '../../utils/queryString';
import { headers, salesServiceUrl } from '../../config';

export function getDebitNote(id) {
    return axios.get(`${salesServiceUrl}/debit-notes/${id}`, { headers: headers() });
}

export function getDebitNotesList(payload) {
    let query = queryString(payload);
    return axios.get(`${salesServiceUrl}/debit-notes?${query}`, { headers: headers() });
}

export function simulateDebitNote({debitNoteId}) {
    return axios.get(`${salesServiceUrl}/debit-notes/${debitNoteId}/simulate`, { headers: headers() });
}

export function postDebitNote({debitNoteId, dpk}) {
    return axios.post(`${salesServiceUrl}/debit-notes/${debitNoteId}/post`, {}, { headers: {...headers(), Dpk: dpk } });
}

export function deleteDebitNote(id) {
    return axios.delete(`${salesServiceUrl}/debit-notes/${id}`, { headers: headers() });
}